<template>
    <div class="bg-default p-24">
        <el-form ref="form" :model="form" size="small" label-position="left" label-width="90px" class="formButtonRight">
            <idc-form-item :form="form" :config="formConfig" col="8" clearable>
                <el-button @click="search" size="small" type="primary" style="margin-left: 12px">
                    查询
                </el-button>
            </idc-form-item>
        </el-form>
        <idc-table :data="tableData" :column="tableColumn" :checkbox="false" :showSlots="['number']" :showOperation="false" operation-width="64px">
            <!-- <template #score="data">
                <div>{{ data.$index }}</div>
            </template> -->
        </idc-table>
        <idc-pager :total="total" :page="pager" @change="pageChange" />
    </div>
</template>

<script>
// import searchPagerMixins from '../../util/mixins/searchPagerMixins';
export default {
    name: 'MoreInfo',
    // mixins: [searchPagerMixins],
    data() {
        return {
            form: {},
            formConfig: [{ itemType: 'date-picker', label: '接手时间：', col: 12, type: 'daterange', valueFormat: 'yyyy-MM-dd', prop: 'createTime' }],
            tableColumn: [{ sourINdex: '序号' }, { title: '消息类型' }, { messageData: '消息内容' }, { opTime: '接收时间' }, { sender: '发送人' }],
            tableData: [],
            total: 1,
            pager: {
                pageNum: 1,
                pageSize: 10
            }
        };
    },
    created() {
        this.search();
    },
    methods: {
        search() {
            //   queryMessagePage  消息  queryBacklogPage   待办

            // pageNum、pageSize、startDate、endDate
            if (this.$route.params.status == 'first') {
                this.$http
                    .get(this.$service.main.queryMessagePage, {
                        params: {
                            pageNum: this.pager.pageNum,
                            pageSize: this.pager.pageSize,
                            startDate: this.form.createTime ? this.form.createTime[0] : '',
                            endDate: this.form.createTime ? this.form.createTime[1] : ''
                        }
                    })
                    .then(res => {
                        this.tableData = res.data.rows || [];
                        this.total = res.data.totalRecords;
                        if (Array.isArray(this.tableData))
                            this.tableData.forEach((item, index) => {
                                item.sourINdex = index + 1;
                                item.sender = item.sender || '系统';
                            });
                    });
            } else {
                this.$http
                    .get(this.$service.main.queryMessagePage, {
                        params: {
                            pageNum: this.pager.pageNum,
                            pageSize: this.pager.pageSize,
                            startDate: this.form.createTime ? this.form.createTime[0] : '',
                            endDate: this.form.createTime ? this.form.createTime[1] : ''
                        }
                    })
                    .then(res => {
                        this.tableData = res.data.rows || [];
                        if (Array.isArray(this.tableData)) this.total = res.data.totalRecords;
                        this.tableData.forEach((item, index) => {
                            item.sourINdex = index + 1;
                            item.sender = item.sender || '系统';
                        });
                    });
            }
        },
        pageChange(data) {
            this.pager = data;
            this.search();
        }
    }
};
</script>
